import { LegalLayout } from "@/components/LegalLayout";

const P = ({ children }) => (
  <p className="text-base text-slate-400 leading-relaxed">{children}</p>
);

const UL = ({ items }) => (
  <ul className="flex flex-col gap-2 pl-1">
    {items.map((item, i) => (
      <li key={i} className="flex items-start gap-3 text-base text-slate-400 leading-relaxed">
        <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#00DC82]" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const Section = ({ children }) => (
  <section className="flex flex-col gap-4">{children}</section>
);

export default function About() {
  return (
    <LegalLayout title="About MockTP">
      <Section>
        <P>
          MockTP was created to give driving instructors a simpler and more professional
          way to run mock driving assessments.
        </P>
        <P>
          The idea came from everyday instructor work: recording faults, managing student
          history, writing reports and trying to keep everything organised without losing
          focus on the lesson itself.
        </P>
        <P>MockTP brings those tasks together in one place.</P>
        <P>It allows instructors to:</P>
        <UL
          items={[
            "Carry out structured mock driving assessments.",
            "Use Ireland (RSA) or Great Britain (DVSA) assessment standards.",
            "Track student progress over time.",
            "Identify areas that need more work.",
            "Produce clear, professional reports for students.",
            "Keep student records organised.",
          ]}
        />
        <P>MockTP is designed to be practical, quick to use and easy to understand.</P>
        <P>
          It is not built around unnecessary features or complicated workflows. The aim is
          simple:
        </P>
        <P>
          <strong className="font-semibold text-white">
            Spend less time on paperwork and more time teaching.
          </strong>
        </P>
        <P>
          MockTP is developed by{" "}
          <strong className="font-semibold text-white">MockTP Labs</strong>.
        </P>
        <P>
          <strong className="font-semibold text-white">
            Built by instructors, for instructors.
          </strong>
        </P>
      </Section>
    </LegalLayout>
  );
}
